import React, { type FC } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb as AntBreadcrumb, type BreadcrumbProps } from 'antd';

import { type BreadcrumbLink, type WithOptionalDataTest } from 'types';
import { CustomerTime } from 'components';
import styles from './breadcrumb.module.scss';

export namespace Breadcrumb {
  export type Props = BreadcrumbProps & {
    links: BreadcrumbLink[];
    hasTime?: boolean;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { dataTestId, links, hasTime = true, ...antProps } = props;
    const handleClick = (event: any, action: any) => {
      // Prevent the default behavior of the Link component and execute the onClick function if it's provided
      if (action) {
        event.preventDefault();
        action();
      }
    };

    return (
      <div>
        <AntBreadcrumb
          separator={'/'}
          data-testid={dataTestId}
          className={styles.breadcrumb}
          items={links.map((link) => {
            return {
              title: link.url ? (
                <Link
                  className={styles.breadcrumb__link}
                  to={link.url}
                  onClick={(e) => {
                    handleClick(e, link.action);
                  }}
                >
                  {link.title}
                </Link>
              ) : (
                link.title
              ),
            };
          })}
          {...antProps}
        />
        {hasTime && <CustomerTime.$ isSticky isSlim />}
      </div>
    );
  };
}
